module.exports = __webpack_public_path__ + "static/media/order_assistant.802090b6.png";